import type { ReactNode } from 'react'
import { useShellMetaCtx, type ShellMeta } from '../shell/AppShell.js'

/**
 * COMPATIBILITÉ LOT 4/5 → LOT 5.5.
 *
 * Le shell (sidebar, header, palette, profil) est devenu PERSISTANT et vit
 * dans shell/AppShell.tsx — il n'est plus monté par chaque page. Les pages
 * des lots gelés continuent d'appeler `<Shell active…>` et `useShellMeta()` :
 * pour ne pas réécrire des écrans validés, ces symboles restent, mais
 *
 *   · Shell ne rend plus QUE le contenu (le vrai shell est déjà là) ;
 *   · useShellMeta lit le contexte partagé — PLUS AUCUN fetch par page
 *     (c'était une des causes des saccades).
 *
 * Toute NOUVELLE page n'utilise plus ces exports.
 */

export type { ShellMeta }
export type ShellActive =
  | 'calendrier'
  | 'dashboard' | 'soirees' | 'rh' | 'security' | 'parc' | 'communication'
  | 'infrastructure' | 'alerts' | 'audit' | 'settings'
  // IA V2 — hubs de famille (la sidebar déduit l'état actif de la ROUTE,
  // ce type ne sert plus qu'aux composants hérités).
  | 'accueil' | 'exploitation' | 'equipe' | 'securite' | 'technique' | 'administration'

export function useShellMeta(): ShellMeta {
  return useShellMetaCtx()
}

export function Shell(props: { active: ShellActive; meta: ShellMeta; children: ReactNode }) {
  return <>{props.children}</>
}
